import { render } from "./ClientDictionaryTable.vue?vue&type=template&id=63d925bb&scoped=true"
import script from "./ClientDictionaryTable.vue?vue&type=script&lang=js"
export * from "./ClientDictionaryTable.vue?vue&type=script&lang=js"

import "./ClientDictionaryTable.vue?vue&type=style&index=0&id=63d925bb&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63d925bb"]])

export default __exports__